import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { __decorate } from "tslib";
import { Module, Mutation, VuexModule } from "~/node_modules/vuex-module-decorators";

var FilesModule = /*#__PURE__*/function (_VuexModule) {
  _inherits(FilesModule, _VuexModule);

  var _super = _createSuper(FilesModule);

  function FilesModule() {
    var _this;

    _classCallCheck(this, FilesModule);

    _this = _super.apply(this, arguments);
    _this.events = [];
    _this.subscriptions = [];
    return _this;
  }

  _createClass(FilesModule, [{
    key: "SET_EVENTS",
    value: function SET_EVENTS(events) {
      this.events = events;
    }
  }, {
    key: "SET_SUBSCRIPTION_EVENTS",
    value: function SET_SUBSCRIPTION_EVENTS(events) {
      this.subscriptions = events;
    }
  }, {
    key: "hasEventsWithFiles",
    get: function get() {
      return this.events.length > 0;
    }
  }, {
    key: "hasSubscriptionsWithFiles",
    get: function get() {
      return this.subscriptions.length > 0;
    }
  }]);

  return FilesModule;
}(VuexModule);

__decorate([Mutation], FilesModule.prototype, "SET_EVENTS", null);

__decorate([Mutation], FilesModule.prototype, "SET_SUBSCRIPTION_EVENTS", null);

FilesModule = __decorate([Module({
  namespaced: true,
  name: 'files',
  stateFactory: true
})], FilesModule);
export default FilesModule;